"use client";

import { Row } from "@faire/web/slate/Layout";
import React from "react";

import { UserDrivenFeedbackButton } from "@faire/retailer/components/UserFeedback/UserDrivenFeedbackButton";
import { useIsLoggedInRetailer } from "@faire/retailer/lib/isLoggedInRetailer";
import { useSettingEnableUserFeedback } from "@faire/retailer/settings/useSettingEnableUserFeedback";

export const MaybeComponentWithUserDrivenFeedbackButton: React.FC<
  React.PropsWithChildren<{
    brandToken?: string;
  }>
> = ({ children, brandToken }) => {
  const isUserLoggedIn = useIsLoggedInRetailer();
  const settingValue = useSettingEnableUserFeedback();
  if (settingValue && isUserLoggedIn) {
    return (
      <Row justify="space-between">
        {children}
        <UserDrivenFeedbackButton brandToken={brandToken} />
      </Row>
    );
  }
  return <>{children}</>;
};
